import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table, Button } from 'react-bootstrap';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPut } from '../../CommonUtils/CommonAxios';
import * as Yup from "yup";
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from 'react-icons/fa';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';

export default function CheckList() {

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const [getDocumentData, setDocumentData] = useState([])
    // const [isSubmitted, setIsSubmitted] = useState(false);

    // ✅ VALIDATION (ALL REQUIRED)
    const validationSchema = Yup.object({
        checkList: Yup.array().of(
            Yup.object({
                recommended: Yup.string().required("Required")
            })
        )
    });

    const formik = useFormik({
        initialValues: { checkList: [] },
        enableReinitialize: true,
        validationSchema,
        onSubmit: (values) => {
            submitStdFcltRatio(values)
        }
    })

    // ✅ GET DATA
    function getBasicDocumentCheckListDataFunc() {
        let url = config.url.FAC_URL + "getDocDtlsCheckList";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                const data = res?.data?.data || [];
                setDocumentData(data);

                formik.setValues({
                    checkList: data.map(item => ({
                        docId: item.doc_id,
                        recommended: item?.inspection_status || "",
                        collCode: item.coll_code,
                        acYear: item.ac_year,
                        userId: item.user_id,
                        sno: item.sno,
                        // isDisabled: item.inspection_status !== null
                        isDisabled: item.inspection_status === "YES" || item.inspection_status === "NO"
                    }))
                });
            } else {
                setDocumentData([])
            }
        })
    }

    useEffect(() => {
        getBasicDocumentCheckListDataFunc()
    }, [])

    const getUploadedDoc = (docId) =>
        getDocumentData.find((d) => d.doc_id === docId) || null;

    // ✅ PAGINATION
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = formik.values.checkList.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(formik.values.checkList.length / rowsPerPage);

    // ✅ SUBMIT
    function submitStdFcltRatio(values) {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "No, Cancel"
        }).then((result) => {
            if (result.isConfirmed) {

                const url = config.url.FAC_URL + "updateInspection";

                const payload = values.checkList.map(item => ({
                    sno: item.sno,
                    inspectionStatus: item.recommended === "YES" ? "YES" : "NO"
                }));

                CommonAxiosPut(url, payload)
                    .then((res) => {
                        if (res?.data?.scode === "01") {
                            successAlert2(res.data.sdesc);
                            // setIsSubmitted(true);
                            getBasicDocumentCheckListDataFunc();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    })
                    .catch(() => {
                        failureAlert("Something went wrong!");
                    });
            }
        });
    }
    // const isSubmitted = getDocumentData.length > 0 &&
    //     getDocumentData.every(item => item.inspection_status !== null);
    const isSubmitted = getDocumentData.length > 0 &&
        getDocumentData.every(
            item => item.inspection_status === "YES" || item.inspection_status === "NO"
        );
    return (
        <Container fluid className="py-3">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    {/* <h5 className="mb-3 innerheader-new text-success"><b>Checklist:</b></h5> */}
                    <h5 className="mb-3 innerheader-new">
                        <span>Checklist</span>
                    </h5>

                    <Row className="mt-4">
                        {/* <Col xs={12}>
                            <Table bordered responsive>
                                <thead className="table-primary">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Document Description</th>
                                        <th>View</th>
                                        <th>Recommended</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRows.length > 0 ? (
                                        formik.values.checkList.map((row, index) => {
                                            const actualIndex = indexOfFirstRow + index;
                                            const item = getDocumentData[actualIndex];
                                            return (
                                                <tr key={actualIndex}>
                                                    <td>{actualIndex + 1}</td>
                                                    <td>{item?.doc_name}</td>
                                                    <td className="text-center">
                                                        <FaEye
                                                            className="me-1"
                                                            style={{ color: "blue", cursor: "pointer" }}
                                                            onClick={() => {
                                                                const doc = getUploadedDoc(item.doc_id);
                                                                if (doc) viewImage(doc.doc_path);
                                                            }}
                                                        />
                                                    </td>

                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center gap-3">

                                                            <label>
                                                                <Field
                                                                    type="radio"
                                                                    name={`checkList.${actualIndex}.recommended`}
                                                                    value="YES"
                                                                    disabled={row.isDisabled || isSubmitted}
                                                                /> YES
                                                            </label>

                                                            <label>
                                                                <Field
                                                                    type="radio"
                                                                    name={`checkList.${actualIndex}.recommended`}
                                                                    value="NO"
                                                                    disabled={row.isDisabled || isSubmitted}
                                                                /> NO
                                                            </label>

                                                        </div>

                                                        <ErrorMessage
                                                            name={`checkList.${actualIndex}.recommended`}
                                                            component="div"
                                                            className="text-danger small text-center"
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center text-danger">
                                                *********No Data Found************
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                          
                            <Row className="mt-3">
                                <Col className="d-flex justify-content-end align-items-center gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage(prev => prev - 1)}
                                    >
                                        ◀ Prev
                                    </button>

                                    <span className="fw-bold">
                                        Page {currentPage} of {totalPages || 1}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        onClick={() => setCurrentPage(prev => prev + 1)}
                                    >
                                        Next ▶
                                    </button>
                                </Col>
                            </Row>

                           
                            {isSubmitted ? (
                                <p className="text-success fw-bold mt-2 text-end">
                                    ✅ Already Submitted
                                </p>
                            ) : (

                                <Row className="mt-4">
                                    <Col xs={12} className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </Col>
                                </Row>
                            )
                            }
                        </Col> */}
                        <Col xs={12}>
                            {getDocumentData.length === 0 ? (
                                <center className="text-danger mt-4 h5">
                                    {" "}
                                    ***** No Data Found *****{" "}
                                </center>
                            ) : (
                                <>
                                    <Table bordered responsive >
                                        <thead className="table-primary">
                                            <tr>
                                                <th>S.No</th>
                                                <th>Document Description</th>
                                                <th>View</th>
                                                <th>Recommended</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {formik.values.checkList.map((row, index) => {
                                                const actualIndex = indexOfFirstRow + index;
                                                const item = getDocumentData[actualIndex];

                                                return (
                                                    <tr key={actualIndex}>
                                                        <td>{actualIndex + 1}</td>
                                                        <td>  {item?.doc_name} ({item?.noc_type})</td>
                                                        <td className="text-center">
                                                            <FaEye
                                                                className="me-1"
                                                                style={{ color: "blue", cursor: "pointer" }}
                                                                onClick={() => {
                                                                    const doc = getUploadedDoc(item.doc_id);
                                                                    if (doc) viewImage(doc.doc_path);
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="d-flex justify-content-center gap-3">
                                                                <label>
                                                                    <Field
                                                                        type="radio"
                                                                        name={`checkList.${actualIndex}.recommended`}
                                                                        value="YES"
                                                                        disabled={row.isDisabled || isSubmitted}
                                                                    /> &nbsp;Yes
                                                                </label>

                                                                <label>
                                                                    <Field
                                                                        type="radio"
                                                                        name={`checkList.${actualIndex}.recommended`}
                                                                        value="NO"
                                                                        disabled={row.isDisabled || isSubmitted}
                                                                    /> &nbsp; No
                                                                </label>
                                                            </div>

                                                            <ErrorMessage
                                                                name={`checkList.${actualIndex}.recommended`}
                                                                component="div"
                                                                className="text-danger small text-center"
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>

                                    {/* Pagination */}
                                    {/* <Row className="mt-3">
                                        <Col className="d-flex justify-content-end align-items-center gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                disabled={currentPage === 1}
                                                onClick={() => setCurrentPage(prev => prev - 1)}
                                            >
                                                ◀ Prev
                                            </button>

                                            <span className="fw-bold">
                                                Page {currentPage} of {totalPages || 1}
                                            </span>

                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                disabled={currentPage === totalPages || totalPages === 0}
                                                onClick={() => setCurrentPage(prev => prev + 1)}
                                            >
                                                Next ▶
                                            </button>
                                        </Col>
                                    </Row> */}

                                    {/* Submit Button */}
                                    {isSubmitted ? (
                                        <p className="text-success fw-bold mt-2 text-end">
                                            ✅ Already Submitted
                                        </p>
                                    ) : (
                                        <Row className="mt-4">
                                            <Col xs={12} className="text-end">
                                                <button type="submit" className="btn btn-primary">
                                                    Submit
                                                </button>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                </Form>
            </FormikProvider>
        </Container>
    )
}